const GRADUATION_ASSET_BASE_URL =
  "https://ykmk-master.oss-cn-shanghai.aliyuncs.com/wechat/assets/graduation-2026";

function buildAssetUrl(fileName) {
  return `${GRADUATION_ASSET_BASE_URL}/${encodeURIComponent(fileName)}`;
}

export const graduationAssets = Object.freeze({
  heroTop: buildAssetUrl("hero-top.png"),
  loginImage: buildAssetUrl("login-img.png"),
  signupBanner: buildAssetUrl("sign-top.png"),
  objectives: buildAssetUrl("Slice 268@2x.png"),
  organization: buildAssetUrl("Slice 268@2x(1).png"),
  timeline: buildAssetUrl("Slice 268@2x(2).png"),
  awards: buildAssetUrl("Slice 268@2x(8).png"),
  collection: buildAssetUrl("Slice 268@2x(9).png"),
  submissionIntro: buildAssetUrl("Slice 268@2x(3).png"),
  criteria: buildAssetUrl("Slice 268@2x(4).png"),
  ip: buildAssetUrl("Slice 268@2x(5).png"),
  statement: buildAssetUrl("Slice 268@2x(6).png"),
  schools: buildAssetUrl("Slice 268@2x(7).png"),
  arrow: buildAssetUrl("Slice 269@2x.png"),
});

export default graduationAssets;
